
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/boka-resor",
      function () {
        return require("private-next-pages/[region]/[resort]/boka-resor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/boka-resor"])
      });
    }
  